export const config = {
  title: "Markowitz Process Service LLC | Legal Document Delivery in Denver, CO",
  meta: {
    description:
      "Markowitz Process Service LLC offers professional, reliable, and prompt process serving in Denver, CO and surrounding areas. Serving legal papers with integrity and discretion.",
    keywords: [
      "process server Denver",
      "Markowitz Process Service LLC",
      "legal document delivery",
      "court papers Denver",
      "document serving Colorado"
    ],
    author: "Markowitz Process Service LLC",
    canonicalUrl: "https://www.markowitzservice.com/",
  },
  sections: {
    header: {
      businessName: "Markowitz Process Service LLC",
    },
    sectionB: {
      heroTitle: "Markowitz Process Service LLC",
      heroSubtitle: "Trusted Legal Document Delivery in Denver, CO",
      learnAboutText: "Request a Service",
      phoneNumber: "7205567191",
      phoneLabel: "(720) 556-7191",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/1275685888/photo/black-man-hands-opens-a-padded-envelope-sitting-at-home.jpg?s=612x612&w=0&k=20&c=PrI7xNatRQ9Zz_jq-JWq_oMYEFEaT14COkTqdULCuP8=",
      cardData: [
        {
          title: "Process Serving",
          description: "Prompt and professional service of legal documents across Colorado.",
        },
        {
          title: "Court Filings",
          description: "Experienced in document filing at various court levels.",
        },
        {
          title: "Document Retrieval",
          description: "Quick access and secure retrieval of court and legal documents.",
        },
      ],
      description:
        "Markowitz Process Service LLC delivers timely and confidential process serving services to law firms, businesses, and individuals throughout Denver and surrounding communities.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "From summons to subpoenas, we ensure that your legal documents are delivered accurately and within the necessary timeframe.",
      cards: [
        {
          title: "Standard & Rush Process Serving",
          description: "Choose the timing that fits your legal needs.",
          imageSrc: "https://media.istockphoto.com/id/2170920443/photo/legal-advisor-delivering-documents-to-client-confidential-legal-exchange.jpg?s=612x612&w=0&k=20&c=vDs_eBSHY2L0aE-q5EPLe0SDFH0ZYWj_dKitXA-bzB4=",
          imageAlt: "Process Serving",
        },
        {
          title: "Skip Tracing",
          description: "Locating difficult-to-find individuals through advanced techniques.",
          imageSrc: "https://media.istockphoto.com/id/1059113626/photo/woman-taking-envelope-with-documents-from-deliverer-hands-door-to-door-shipment.jpg?s=612x612&w=0&k=20&c=RLfAtiKXnl34u1K_DRXTQ2aXU5LSGKxt3lzUUXE9_2Q=",
          imageAlt: "Skip Tracing",
        },
        {
          title: "Notary Services",
          description: "Mobile notary service available upon request.",
          imageSrc: "https://media.istockphoto.com/id/1436355269/photo/signing-official-document.jpg?s=612x612&w=0&k=20&c=f8fzSk-zHVAsa-r5EELsLoydFR_iTOkjUG3W4AYLIEg=",
          imageAlt: "Notary Service",
        },
      ],
      otherServicesTitle: "Why Choose Us",
      otherServicesList: [
        "Reliable & Punctual",
        "Locally Owned & Operated",
        "Confidential & Secure Handling",
        "Affordable & Transparent Pricing",
        "Experienced in Legal Protocol"
      ],
    },
    sectionD: {
      aboutTitle: "About Markowitz Process Service LLC",
      aboutImage: {
        src: "https://media.istockphoto.com/id/2186260644/photo/businessman-stamping-a-document-at-his-desk.jpg?s=612x612&w=0&k=20&c=T5ol8MosvbrVC2kRTKdvZpckDEDFLwMGX6mC0eaS_zc=",
        alt: "Markowitz Process Service Team",
      },
      aboutText: [
        "Markowitz Process Service LLC has built a reputation for integrity and precision in legal document handling throughout Colorado.",
        "We work closely with law firms, government agencies, and private clients to ensure all documents are delivered professionally and on time."
      ],
    },
    sectionE: {
      profileImage: "https://static.wixstatic.com/media/2d931b_ef5c555b68224f9c8008dbe48cbe7e1e~mv2.jpg/v1/fill/w_488,h_353,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Markowitz_edited.jpg",
      profileAlt: "Markowitz Process Service Logo",
      businessName: "Markowitz Process Service LLC",
      contact: {
        phone: "7205567191",
        phoneLabel: "(720) 556-7191",
        email: "nick@markowitzservice.com",
        website: "https://www.markowitzservice.com/",
        address: "Denver, Colorado, USA",
      },
      socialMedia: {},
    },
    sectionF: {
      address: "Denver, Colorado, USA",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d12272.029644567868!2d-104.9998246!3d39.7392364!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x876c78d4c34d12d3%3A0x5e7c0f546b6715c2!2sDenver%2C%20CO!5e0!3m2!1sen!2sus!4v1691548349827",
    },    
  },
};

export default config;
